import { useMountedState } from 'react-use';

import { ErrorIcon } from '@/ui/Icons/ErrorIcon';
import { SwapIcon } from '@/ui/Icons/SwapIcon';

import { buttons } from '../../../../styles/buttons';
import { LoadingSpinner } from '../../../../ui/Icons/Animated/LoadingSpinner';

interface Props {
  isTokenBlocked: boolean;
  onClick: () => void;
}

export default function TransactionModuleMobileCTA({ isTokenBlocked, onClick }: Props) {
  const isMounted = useMountedState();

  if (!isMounted()) {
    return (
      <button className={buttons({ size: 'large', color: 'black' })} disabled type="button">
        <LoadingSpinner variant="white" />
      </button>
    );
  }

  if (isTokenBlocked) {
    return (
      <button className={buttons({ size: 'large', color: 'red', shape: 'pill' })} onClick={onClick}>
        <ErrorIcon />
        <span className="ml-2">Unsupported Token</span>
      </button>
    );
  }

  return (
    <button className={buttons({ size: 'large', color: 'black', shape: 'pill' })} onClick={onClick}>
      <SwapIcon className="h-6 mr-1" />
      Trade
    </button>
  );
}
